import { PayoutRuleType } from '@common-fe/common-fe';

export const PAYOUT_RULE_OPTIONS = [
  {
    key: PayoutRuleType.NO_EXCEPTIONS,
    value: 'No exceptions',
    hintIconText:
      'Account payment order will be used to process claims based on each tiers configured payout definition.',
  },
  {
    key: PayoutRuleType.WITH_EXCEPTIONS,
    value: 'With exceptions',
    hintIconText: 'Account payment order will be used but exceptions can be configured within each tier.',
  },
  {
    key: PayoutRuleType.EXCEPTIONS_ONLY,
    value: 'Exceptions only',
    hintIconText:
      'Account payment order will not be used. Claims will only pay according to each tiers specific rules.',
  },
];
